'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _input = require('../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostalCode = function (_React$Component) {
    _inherits(PostalCode, _React$Component);

    function PostalCode(props) {
        _classCallCheck(this, PostalCode);

        var _this = _possibleConstructorReturn(this, (PostalCode.__proto__ || Object.getPrototypeOf(PostalCode)).call(this, props));

        _this.isValidPostalCode = function (value) {
            return new RegExp(/^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] [0-9][ABCEGHJ-NPRSTV-Z][0-9]$/).test(value);
        };

        _this.handleChange = function (value, part) {
            var postalCode = part === 1 ? value + ' ' + _this.state.postalCodeTwo : _this.state.postalCodeOne + ' ' + value;
            var valid = _this.isValidPostalCode(postalCode);
            _this.props.changeEvent('postalCode', postalCode);
        };

        _this.state = {
            postalCodeOne: '',
            postalCodeTwo: ''
        };
        return _this;
    }

    _createClass(PostalCode, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.value && this.isValidPostalCode(this.props.value)) {
                var splitPostalCode = this.props.value.split(' ');
                this.setState({
                    postalCodeOne: splitPostalCode[0],
                    postalCodeTwo: splitPostalCode[1]
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    { nogutter: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12, nogutterleft: true },
                        _react2.default.createElement(_label2.default, { text: this.props.label, bottom: _sizes.Sizes.xxs, textAlign: _alignments.Alignments.left, disabled: this.props.disabled, size: _sizes.Sizes.md })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 6, nogutterleft: true },
                        _react2.default.createElement(_input2.default, {
                            placeholder: 'A1B',
                            maxLength: 3,
                            textAlign: _alignments.Alignments.center,
                            value: this.state.postalCodeOne,
                            changeEvent: function changeEvent(value) {
                                value = value.toUpperCase();
                                var valid = true;
                                if (value.length === 1) {
                                    valid = new RegExp(/^[A-Z]$/).test(value);
                                } else if (value.length === 2) {
                                    valid = new RegExp(/^[A-Z][0-9]$/).test(value);
                                } else if (value.length === 3) {
                                    valid = new RegExp(/^[A-Z][0-9][A-Z]$/).test(value);
                                }
                                _this2.handleChange(value, 1);
                                _this2.setState({ postalCodeOne: value });
                            }
                        })
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 6, nogutterright: true },
                        _react2.default.createElement(_input2.default, {
                            placeholder: '2C3',
                            maxLength: 3,
                            textAlign: _alignments.Alignments.center,
                            value: this.state.postalCodeTwo,
                            changeEvent: function changeEvent(value) {
                                value = value.toUpperCase();
                                var valid = true;
                                if (value.length === 1) {
                                    valid = new RegExp(/^[0-9]$/).test(value);
                                } else if (value.length === 2) {
                                    valid = new RegExp(/^[0-9][A-Z]$/).test(value);
                                } else if (value.length === 3) {
                                    valid = new RegExp(/^[0-9][A-Z][0-9]$/).test(value);
                                }
                                _this2.handleChange(value, 2);
                                _this2.setState({ postalCodeTwo: value });
                            }
                        })
                    )
                )
            );
        }
    }]);

    return PostalCode;
}(_react2.default.Component);

exports.default = PostalCode;